import "./index.scss"
import Bussiness from "../business"
import Platform from "../platforms"
import Workforce from "../workforce"
import LeaveManagement from "../leave"
import Faqs from "../faqs"
import RecentBlogs from "../recent-blogs"
import Card from "../card"
import AutoPlay from "../../layout/industry-slide"
import { Helmet } from 'react-helmet-async';
import {ReactComponent as Education} from "../../../assets/logos/education.svg"
import {ReactComponent as Healthcare} from "../../../assets/logos/health-care.svg"
import {ReactComponent as Crane} from "../../../assets/logos/crane.svg"
import {ReactComponent as Clean} from "../../../assets/logos/clean.svg"
import {ReactComponent as Bus} from "../../../assets/logos/bus.svg"
import {ReactComponent as Food} from "../../../assets/logos/food.svg"
import {ReactComponent as Media} from "../../../assets/logos/media.svg"
import {ReactComponent as Flight} from "../../../assets/logos/flight.svg"
import {ReactComponent as Shopping} from "../../../assets/logos/shopping.svg"
import {ReactComponent as Financial} from "../../../assets/logos/financial.svg"
import {ReactComponent as Computer} from "../../../assets/logos/computer.svg"

const data = [
    {id:'field1', icon:<Education className="mr" />, name:'Education'},
    {id:'field2', icon:<Healthcare className="mr"/>, name:'Healthcare'},
    {id:'field3', icon:<Bus className="mr"/>, name:'Automobile'},
    {id:'field4', icon:<Crane className="mr"/>, name:'Manufacturing'},
    {id:'field5', icon:<Food className="mr"/>, name:'Food'},
    {id:'field6', icon:<Clean className="mr"/>, name:'Textiles'},
    {id:'field7', icon:<Computer className="mr"/>, name:'Information\u00A0Technology'},
    {id:'field8', icon:<Financial className="mr"/>, name:'Financial\u00A0Services'},
    {id:'field9', icon:<Shopping className="mr"/>, name:'FMCG'},
    {id:'field10', icon:<Flight className="mr"/>, name:'Transportation/Logistics'},
    {id:'field11', icon:<Media className="mr"/>, name:'Media'},
]

const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed:0,
    cssEase: "linear",
    centerMode:true,
    pauseOnHover:false,
};


const Home = () => {

    return(
        <>
            <Helmet>
                <title>Walkzero: India’s Unified HR Platform | Payroll Software </title>
            </Helmet>
            <Bussiness />
            <AutoPlay data={data} settings={settings} />
            <Platform />
            <Workforce />
            <LeaveManagement />
            <Faqs />
            <RecentBlogs />
            <Card />
        </>
    )
}

export default Home